import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=16839785&scoped=true&"
import script from "./Index.js?vue&type=script&lang=js&"
export * from "./Index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=16839785&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16839785",
  null
  
)

export default component.exports